import { Component, Input } from '@angular/core';

import { IReactWidgetParams, ReactComponent } from '@shared/widget/react.component';

export interface IReactWidgetFaiEligParams extends IReactWidgetParams {
    elig_title?: string;
    title?: string;
    button_label?: string;
    endpoint?: string;
    show_migration_link?: boolean;
    focus?: string;
    show_icon?: boolean;
}

@Component({
    selector: 'checkout-fai-elig-widget',
    template: '<div class="column pl-0 pr-0" #widget></div>',
    standalone: true,
})
export class FaiEligWidgetComponent extends ReactComponent {
    @Input() protected params: IReactWidgetFaiEligParams;
    protected widgetConfig = {
        src: this.configurationService.getData()?.global.widgets.faiWidget.src,
        identifier: 'fai-eligibility-widget',
    };
}
